export default __webpack_public_path__ + "static/media/gold_coin.c3066266.svg";